import { Paragraph } from "./dom";

export function matchesParagraphSelectors(
  para: Paragraph,
  selectors?: string | string[],
): boolean {
  const selectorList = normalizeSelectorList(selectors);
  if (selectorList.length === 0) return false;

  for (const selector of selectorList) {
    if (paragraphMatchesSelector(para, selector)) return true;
  }

  return false;
}

export function paragraphMatchesSelector(para: Paragraph, selector: string): boolean {
  const ancestor = para.commonAncestor;
  if (ancestor.nodeType === Node.ELEMENT_NODE) {
    const ancestorEl = ancestor as Element;
    if (ancestorEl.matches(selector) || ancestorEl.closest(selector)) return true;
  }

  for (const node of para.flatNodes) {
    const parentEl = node.nodeType === Node.TEXT_NODE
      ? (node as Text).parentElement
      : (node as Element);
    if (!parentEl) continue;
    if (parentEl.matches(selector) || parentEl.closest(selector)) return true;
  }

  return false;
}

function normalizeSelectorList(selectors?: string | string[]): string[] {
  if (!selectors) return [];
  const list = Array.isArray(selectors) ? selectors : [selectors];
  return list
    .map(item => item.trim())
    .filter(Boolean);
}
